<template>
<div style="height: 500px">
  <iframe id="mainIframe" ref="mainIframe" name="mainIframe"
          style="width: 100%;height: 100%;margin: auto"
          src="https://jiaold.com/calldeviceyknew/"
          allow="microphone;camera"
          frameborder="0"
          scrolling="no">
  </iframe>
</div>
</template>

<script>
export default {
  name: 'visitVideo',
  model: {
    prop: 'videoShow',
    event: 'change'
  },
  props: {
    visitObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {}
  },
  created () {
  },
  mounted () {
    setTimeout(() => {
      this.callVideo()
    }, 800)
  },
  methods: {
    callVideo () {
      // let callimei = this.visitObj.row.device_id
      let callimei = '353537067298608'
      let autoreceive = 0
      window.frames['mainIframe'].postMessage({callimei: callimei, autoreceive: autoreceive}, '*')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/visitVideo.vue